const styles = (theme) => ({
  container: {
    paddingTop: theme.spacing(5),
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  typography: {
    margin: theme.spacing(4),
  },
  text: {
    paddingBottom: theme.spacing(2),
  },
  buttonContainer: {
    margin: theme.spacing(4),
    marginTop: theme.spacing(6),
  },
});

export default styles;
